function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg153UnitedStatesOfAmerica(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    y: 192,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    y: 320,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    y: 448,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 64
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2E52B2"
    },
    width: 256,
    height: 275.69
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "51.518,115.318 45.924,132.529 27.826,132.529 42.469,143.163 36.875,160.375    51.518,149.741 66.155,160.375 60.56,143.163 75.203,132.529 57.106,132.529  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "57.106,194.645 51.518,177.434 45.924,194.645 27.826,194.645 42.469,205.279    36.875,222.49 51.518,211.857 66.155,222.49 60.56,205.279 75.203,194.645  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "51.518,53.202 45.924,70.414 27.826,70.414 42.469,81.047 36.875,98.259 51.518,87.625    66.155,98.259 60.56,81.047 75.203,70.414 57.106,70.414  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "128.003,115.318 122.409,132.529 104.311,132.529 118.954,143.163 113.36,160.375    128.003,149.741 142.64,160.375 137.045,143.163 151.689,132.529 133.591,132.529  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "133.591,194.645 128.003,177.434 122.409,194.645 104.311,194.645 118.954,205.279    113.36,222.49 128.003,211.857 142.64,222.49 137.045,205.279 151.689,194.645  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "210.076,194.645 204.489,177.434 198.894,194.645 180.797,194.645 195.44,205.279    189.845,222.49 204.489,211.857 219.125,222.49 213.531,205.279 228.174,194.645  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "204.489,115.318 198.894,132.529 180.797,132.529 195.44,143.163 189.845,160.375    204.489,149.741 219.125,160.375 213.531,143.163 228.174,132.529 210.076,132.529  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "128.003,53.202 122.409,70.414 104.311,70.414 118.954,81.047 113.36,98.259    128.003,87.625 142.64,98.259 137.045,81.047 151.689,70.414 133.591,70.414  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "204.489,53.202 198.894,70.414 180.797,70.414 195.44,81.047 189.845,98.259    204.489,87.625 219.125,98.259 213.531,81.047 228.174,70.414 210.076,70.414  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg153UnitedStatesOfAmerica);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+CjxnPgoJPHJlY3QgeT0iNjQiIHN0eWxlPSJmaWxsOiNEODAwMjc7IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjY0Ii8+Cgk8cmVjdCB5PSIxOTIiIHN0eWxlPSJmaWxsOiNEODAwMjc7IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjY0Ii8+Cgk8cmVjdCB5PSIzMjAiIHN0eWxlPSJmaWxsOiNEODAwMjc7IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjY0Ii8+Cgk8cmVjdCB5PSI0NDgiIHN0eWxlPSJmaWxsOiNEODAwMjc7IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjY0Ii8+CjwvZz4KPHJlY3Qgc3R5bGU9ImZpbGw6IzJFNTJCMjsiIHdpZHRoPSIyNTYiIGhlaWdodD0iMjc1LjY5Ii8+CjxnPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHBvaW50cz0iNTEuNTE4LDExNS4zMTggNDUuOTI0LDEzMi41MjkgMjcuODI2LDEzMi41MjkgNDIuNDY5LDE0My4xNjMgMzYuODc1LDE2MC4zNzUgICAgNTEuNTE4LDE0OS43NDEgNjYuMTU1LDE2MC4zNzUgNjAuNTYsMTQzLjE2MyA3NS4yMDMsMTMyLjUyOSA1Ny4xMDYsMTMyLjUyOSAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojRjBGMEYwOyIgcG9pbnRzPSI1Ny4xMDYsMTk0LjY0NSA1MS41MTgsMTc3LjQzNCA0NS45MjQsMTk0LjY0NSAyNy44MjYsMTk0LjY0NSA0Mi40NjksMjA1LjI3OSAgICAzNi44NzUsMjIyLjQ5IDUxLjUxOCwyMTEuODU3IDY2LjE1NSwyMjIuNDkgNjAuNTYsMjA1LjI3OSA3NS4yMDMsMTk0LjY0NSAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojRjBGMEYwOyIgcG9pbnRzPSI1MS41MTgsNTMuMjAyIDQ1LjkyNCw3MC40MTQgMjcuODI2LDcwLjQxNCA0Mi40NjksODEuMDQ3IDM2Ljg3NSw5OC4yNTkgNTEuNTE4LDg3LjYyNSAgICA2Ni4xNTUsOTguMjU5IDYwLjU2LDgxLjA0NyA3NS4yMDMsNzAuNDE0IDU3LjEwNiw3MC40MTQgICIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHBvaW50cz0iMTI4LjAwMywxMTUuMzE4IDEyMi40MDksMTMyLjUyOSAxMDQuMzExLDEzMi41MjkgMTE4Ljk1NCwxNDMuMTYzIDExMy4zNiwxNjAuMzc1ICAgIDEyOC4wMDMsMTQ5Ljc0MSAxNDIuNjQsMTYwLjM3NSAxMzcuMDQ1LDE0My4xNjMgMTUxLjY4OSwxMzIuNTI5IDEzMy41OTEsMTMyLjUyOSAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojRjBGMEYwOyIgcG9pbnRzPSIxMzMuNTkxLDE5NC42NDUgMTI4LjAwMywxNzcuNDM0IDEyMi40MDksMTk0LjY0NSAxMDQuMzExLDE5NC42NDUgMTE4Ljk1NCwyMDUuMjc5ICAgIDExMy4zNiwyMjIuNDkgMTI4LjAwMywyMTEuODU3IDE0Mi42NCwyMjIuNDkgMTM3LjA0NSwyMDUuMjc5IDE1MS42ODksMTk0LjY0NSAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojRjBGMEYwOyIgcG9pbnRzPSIyMTAuMDc2LDE5NC42NDUgMjA0LjQ4OSwxNzcuNDM0IDE5OC44OTQsMTk0LjY0NSAxODAuNzk3LDE5NC42NDUgMTk1LjQ0LDIwNS4yNzkgICAgMTg5Ljg0NSwyMjIuNDkgMjA0LjQ4OSwyMTEuODU3IDIxOS4xMjUsMjIyLjQ5IDIxMy41MzEsMjA1LjI3OSAyMjguMTc0LDE5NC42NDUgICIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHBvaW50cz0iMjA0LjQ4OSwxMTUuMzE4IDE5OC44OTQsMTMyLjUyOSAxODAuNzk3LDEzMi41MjkgMTk1LjQ0LDE0My4xNjMgMTg5Ljg0NSwxNjAuMzc1ICAgIDIwNC40ODksMTQ5Ljc0MSAyMTkuMTI1LDE2MC4zNzUgMjEzLjUzMSwxNDMuMTYzIDIyOC4xNzQsMTMyLjUyOSAyMTAuMDc2LDEzMi41MjkgICIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHBvaW50cz0iMTI4LjAwMyw1My4yMDIgMTIyLjQwOSw3MC40MTQgMTA0LjMxMSw3MC40MTQgMTE4Ljk1NCw4MS4wNDcgMTEzLjM2LDk4LjI1OSAgICAxMjguMDAzLDg3LjYyNSAxNDIuNjQsOTguMjU5IDEzNy4wNDUsODEuMDQ3IDE1MS42ODksNzAuNDE0IDEzMy41OTEsNzAuNDE0ICAiLz4KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiNGMEYwRjA7IiBwb2ludHM9IjIwNC40ODksNTMuMjAyIDE5OC44OTQsNzAuNDE0IDE4MC43OTcsNzAuNDE0IDE5NS40NCw4MS4wNDcgMTg5Ljg0NSw5OC4yNTkgICAgMjA0LjQ4OSw4Ny42MjUgMjE5LjEyNSw5OC4yNTkgMjEzLjUzMSw4MS4wNDcgMjI4LjE3NCw3MC40MTQgMjEwLjA3Niw3MC40MTQgICIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };